window.luiReferenceControllers = window.luiReferenceControllers || [];
window.luiReferenceControllers.push(function (application, Stimulus) {
    application.register("comp_references_single_conteg", class extends Stimulus.Controller {
  async connect() {
    const self = this;

    this._scenes = self.targets.findAll('scene')
    this._gsapTweens = [];
    await importScript([cdnjs.gsap, cdnjs.gsapScrollTrigger]);
    gsap.registerPlugin(ScrollTrigger);

    if (this._scenes.length < 1) {
      return
    }

    ScrollTrigger.matchMedia({
      '(min-width: 60em)': () => {
        this._scenes.forEach((scene) => {
          const cards = Array.from(scene.querySelectorAll('[data-target~="comp_references_single_conteg.card"]'))

          if (cards.length < 2) {
            return
          }

          const cardPeek = 72
          const scaleStep = 0.025
          const scrollStep = 140

          ScrollTrigger.saveStyles(scene)

          const timeline = gsap.timeline({
            scrollTrigger: {
              trigger: scene,
              start: 'top-=200 top',
              end: () => `+=${scrollStep * (cards.length - 1)}`,
              scrub: true,
              pin: true,
              invalidateOnRefresh: true,
              onRefresh: (trigger) => {
                if (trigger.pinSpacer) {
                  trigger.pinSpacer.style.marginTop = '0px'
                }
              },
              markers: false
            }
          })

          this._gsapTweens.push(timeline)

          gsap.set(scene, {
            height: () => {
              const cardHeight = Math.max(...cards.map((card) => card.offsetHeight))

              return cardHeight + ((cards.length - 1) * cardPeek)
            }
          })

          cards.forEach((card, index) => {
            ScrollTrigger.saveStyles(card)
            gsap.set(card, {
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              y: () => index === 0 ? 0 : window.innerHeight + card.offsetHeight,
              zIndex: index + 1,
              scale: 1,
              transformOrigin: '50% 0%'
            })
          })

          cards.forEach((card, index) => {
            if (index === 0) {
              return
            }

            timeline.to(card, {
              y: index * cardPeek,
              duration: 0.55,
              ease: 'none'
            }, (index - 1) * 0.65)

            timeline.to(cards.slice(0, index), {
              scale: (cardIndex, target) => 1 - Math.min(index - cards.indexOf(target), 4) * scaleStep,
              duration: 0.25,
              ease: 'none'
            }, '<')
          })
        })
      }
    })
  }

    disconnect() {
        if (!this._gsapTweens) {
            return
        }

        this._gsapTweens.forEach((tween) => {
            if (tween.scrollTrigger) {
                tween.scrollTrigger.kill()
            }

            tween.kill()
        })

        this._gsapTweens = []
    }
});
});
window.luiRegisterReferenceControllers && window.luiRegisterReferenceControllers();
